/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import { PackagingHistoryFragmentFragmentDoc } from './packagingHistoryFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Base_Unit_Type_Enum =
  | 'BAG'
  | 'BAG_IN_BOX'
  | 'BOTTLE'
  | 'BOX'
  | 'BOX_SET'
  | 'BULK'
  | 'CAN'
  | 'CARTON'
  | 'CUP'
  | 'FLASK'
  | 'JAR'
  | 'KEG'
  /**   */
  | 'NET'
  | 'PACK'
  | 'PIECE'
  | 'SACHET'
  | 'SLICE'
  | 'SPRAY'
  | 'TIN'
  | 'TRAY'
  /**   */
  | 'TUB'
  | 'TUBE';

export type Billing_Type_Enum =
  /** billed per unit */
  | 'FIXED'
  /** billed per measured weight */
  | 'WEIGHT_DEPENDENT';

export type Measurement_Unit_Enum =
  | 'CL'
  | 'G'
  | 'KG'
  | 'L'
  | 'ML'
  | 'T'
  /** Used to count units in logistical packages */
  | 'UNIT';

export type Product_Label_Name_Enum =
  | 'AGRICULTURE_BIOLOGIQUE'
  | 'APPELLATION_ORIGINE_CONTROLEE'
  | 'APPELLATION_ORIGINE_PROTEGEE'
  | 'ECOCERT_ECODETERGENT'
  | 'GOUTEZ_ARDECHE'
  | 'HAUTE_VALEUR_ENVIRONNEMENTALE'
  | 'INDICATION_GEOGRAPHIQUE_PROTEGEE'
  | 'LABEL_ROUGE'
  | 'LE_PORC_FRANCAIS'
  | 'NATURE_ET_PROGRES'
  | 'ORIGINE_FRANCE_GARANTIE'
  | 'PRODUIT_ILE_DE_FRANCE'
  | 'SAVEURS_DE_NORMANDIE'
  | 'VALEURS_PARC_NATUREL_REGIONAL';

export type Trade_Item_Unit_Descriptor_Enum =
  | 'CASE'
  | 'CRATE'
  | 'DISPLAY'
  | 'HALF_CASE'
  | 'PALLET'
  | 'SACK'
  /** Used when base units are sold individually */
  | 'UNIT';

export type PackagingVersionByIdQueryVariables = Exact<{
  id: string;
}>;


export type PackagingVersionByIdQuery = { packaging_history_by_pk: { id: string, company_id: string | null, content_measurement_unit: Types.Measurement_Unit_Enum | null, gtin: string | null, trade_item_unit_descriptor: Types.Trade_Item_Unit_Descriptor_Enum, unit_quantity: number | null, net_content: number | null, sku: number, price: number, base_unit: { id: string, gtin: string | null, sku: number | null, content_measurement_unit: Types.Measurement_Unit_Enum | null, unit_quantity: number | null, unit_type: Types.Base_Unit_Type_Enum | null, billing_type: Types.Billing_Type_Enum, unit_net_content: number | null, main_photo: { domain: string | null, path: string } | null, photos: Array<{ photo: { domain: string | null, path: string } | null }> } | null, product: { id: string, name: string, sku: number, sub_family: string, vat_rate: number | null, ingredients: string | null, allergens: string | null, calories: number | null, calories_kj: number | null, fat: number | null, saturated_fat: number | null, carbohydrate: number | null, sugars: number | null, sodium: number | null, protein: number | null, labels: Array<{ label: Types.Product_Label_Name_Enum }> } | null } | null };


export const PackagingVersionByIdDocument = /*#__PURE__*/ gql`
    query PackagingVersionById($id: uuid!) {
  packaging_history_by_pk(id: $id) {
    ...packagingHistoryFragment
  }
}
    ${PackagingHistoryFragmentFragmentDoc}`;

/**
 * __usePackagingVersionByIdQuery__
 *
 * To run a query within a React component, call `usePackagingVersionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackagingVersionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackagingVersionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePackagingVersionByIdQuery(baseOptions: Apollo.QueryHookOptions<PackagingVersionByIdQuery, PackagingVersionByIdQueryVariables> & ({ variables: PackagingVersionByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackagingVersionByIdQuery, PackagingVersionByIdQueryVariables>(PackagingVersionByIdDocument, options);
      }
export function usePackagingVersionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackagingVersionByIdQuery, PackagingVersionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackagingVersionByIdQuery, PackagingVersionByIdQueryVariables>(PackagingVersionByIdDocument, options);
        }
// @ts-ignore
export function usePackagingVersionByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PackagingVersionByIdQuery, PackagingVersionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<PackagingVersionByIdQuery, PackagingVersionByIdQueryVariables>;
export function usePackagingVersionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PackagingVersionByIdQuery, PackagingVersionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<PackagingVersionByIdQuery | undefined, PackagingVersionByIdQueryVariables>;
export function usePackagingVersionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PackagingVersionByIdQuery, PackagingVersionByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PackagingVersionByIdQuery, PackagingVersionByIdQueryVariables>(PackagingVersionByIdDocument, options);
        }
export type PackagingVersionByIdQueryHookResult = ReturnType<typeof usePackagingVersionByIdQuery>;
export type PackagingVersionByIdLazyQueryHookResult = ReturnType<typeof usePackagingVersionByIdLazyQuery>;
export type PackagingVersionByIdSuspenseQueryHookResult = ReturnType<typeof usePackagingVersionByIdSuspenseQuery>;
export type PackagingVersionByIdQueryResult = Apollo.QueryResult<PackagingVersionByIdQuery, PackagingVersionByIdQueryVariables>;